import { PersonalManagersList } from '@my-account/const';
import { createSelector, MemoizedSelector } from '@ngrx/store';
import { StateUtils } from '@spartacus/core';
import { MyAccountState, StateWithMyAccount } from '../my-account-state';
import { getMyAccountState } from './state.selectors';

export const getPersonalManagersList: MemoizedSelector<
  StateWithMyAccount,
  StateUtils.LoaderState<PersonalManagersList>
> = createSelector(getMyAccountState, (state: MyAccountState) => state.personalManagersList);

export const getPersonalManagersListSuccess: MemoizedSelector<StateWithMyAccount, boolean> = createSelector(
  getPersonalManagersList,
  (state) => StateUtils.loaderSuccessSelector(state),
);

export const getPersonalManagersListError: MemoizedSelector<StateWithMyAccount, boolean> = createSelector(
  getPersonalManagersList,
  (state) => StateUtils.loaderErrorSelector(state),
);

export const getPersonalManagersListValue: MemoizedSelector<StateWithMyAccount, PersonalManagersList> = createSelector(
  getPersonalManagersList,
  (state) => StateUtils.loaderValueSelector(state),
);

export const getPersonalManagersListLoading: MemoizedSelector<StateWithMyAccount, boolean> = createSelector(
  getPersonalManagersList,
  (state) => StateUtils.loaderLoadingSelector(state),
);
